(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskFilter',
	};

	var form_id = 'taskfilter-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// update the preview when the value of one of the asset dropdowns (scene, text, photo etc.) change
		$('.filter-field').change(function onFieldChange(e)
		{
			var form_field        = '',
			    filter_values_set = false;

			$('.filter-field').each(function eachField()
			{
				form_field = $(this).val();

				if (form_field.length > 0) {
					filter_values_set = true;
				}
			});

			if (filter_values_set) {
				$('.filter-save-as-field').removeClass('hidden');
			} else {
				$('.filter-save-as-field').addClass('hidden');
			}
		});

		// toggle save as filter for date changes
		$('#' + form_id + 'due_date_start').on('dp.change', function startDateChanged(event) {
			var start_date = event.date;

			if (start_date) {
				$('.filter-save-as-field').removeClass('hidden');
			} else {
				$('.filter-field').trigger('change');
			}
		});

		$('#' + form_id + 'due_date_end').on('dp.change', function endDateChanged(event) {
			var end_date = event.date;

			if (end_date) {
				$('.filter-save-as-field').removeClass('hidden');
			} else {
				$('.filter-field').trigger('change');
			}
		});

		// checking the save as filter checkbox
		$('#' + form_id + 'save_as_filter').change(function onCheckboxChange(e)
		{
			var checked = $(this).is(':checked');

			if (checked) {
				$('.filter-name-field').removeClass('hidden');
				$('.submit-filter').text('Save Filter');
			} else {
				$('.filter-name-field').addClass('hidden');
				$('.submit-filter').text('Search');
			}
		});

		// checking the include completed tasks checkbox
		$('#' + form_id + 'include_completed').change(function onCheckboxChange(e)
		{
			var checked = $(this).is(':checked');

			if (checked) {
				$('.completed-date-field').removeClass('hidden');
			} else {
				$('.completed-date-field').addClass('hidden');
			}
		});

		$('#' + form_id + 'include_completed').trigger('change');

		// adding task tags to the filter search
		Adzuki.TaskManager.initTaskTagFields(form_id);
	};
}(jQuery, window.Adzuki || {}));
